export const DashboardConst = {
    ApiName: 'api/Dashboard',
    getCountOfRequestsAssignedToMe: '/GetCountOfRequestsAssignedToMe',
    getCountOfRequestsCreatedByMe: '/GetCountOfRequestsCreatedByMe',
    getCountOfRequestIssueTypes: '/GetCountOfRequestIssueTypes',
    getRequestDetails: '/GetRequestDetails',
    getCountOfRequestsAssignedToGroup: '/GetCountOfRequestsAssignedToGroup',
}